import React from 'react';
import { Router } from 'wouter';
import { useStore } from '@tanstack/react-store';
import { galleryStore } from './store';
import RouterComponent from './router';
import QueryProvider from './provider/query-provider';
import ImagePreview from './components/ImagePreview';

function App() {
    const dialogGallerySlider = useStore(galleryStore, (state) => state);
    return (
        <QueryProvider>
            <Router>
                <RouterComponent />
            </Router>
            {dialogGallerySlider.open && <ImagePreview />}
        </QueryProvider>
    );
}

export default App;
